import { Icon, IconProps } from '@chakra-ui/react'

export default function MedicalRecord(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1551 7.6584L14.5719 8.38037C14.802 8.77887 14.6653 9.28908 14.2668 9.51917L12.501 10.5388L14.2668 11.5584C14.6653 11.7885 14.802 12.2987 14.5719 12.6972L14.1551 13.4191C13.925 13.8176 13.4147 13.9544 13.0163 13.7243L11.2505 12.7047V14.7438C11.2505 15.204 10.877 15.5775 10.4168 15.5775H9.58315C9.12296 15.5775 8.74947 15.204 8.74947 14.7438V12.7047L6.98374 13.7243C6.58524 13.9544 6.07503 13.8176 5.84493 13.4191L5.42809 12.6972C5.19799 12.2987 5.33472 11.7885 5.73322 11.5584L7.49895 10.5388L5.73322 9.51917C5.33388 9.28908 5.19799 8.77887 5.42809 8.38037L5.84493 7.6584C6.07503 7.2599 6.58524 7.12318 6.98374 7.35327L8.74947 8.37286V6.33368C8.74947 5.87349 9.12296 5.5 9.58315 5.5H10.4168C10.877 5.5 11.2505 5.87349 11.2505 6.33368V8.37286L13.0163 7.35327C13.4156 7.12318 13.925 7.2599 14.1551 7.6584Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.0023C5.85494 18.0023 2.49687 14.6418 2.49687 10.4992C2.49687 6.35666 5.85494 2.99609 10 2.99609C14.1426 2.99609 17.5031 6.35666 17.5031 10.4992C17.5031 14.6418 14.1426 18.0023 10 18.0023"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
